import { Component } from '@angular/core';
import { BasicList } from '../../../../classes';
import { ProductImageApi, LoopBackConfig } from '../../../../../assets/js/lb-sdk';
import { BsModalService } from 'ngx-bootstrap';
import { ProductImageFormComponent } from './product-image-form/product-image-form.component';
import { ProductsService } from '../../../../services';
import { STORAGE_LOCATIONS } from '../../../../enums';
import { Event } from '../../../../interfaces';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-product-image',
  templateUrl: './product-image.component.html',
  styleUrls: ['./product-image.component.css']
})
export class ProductImageComponent extends BasicList {
  host:string = LoopBackConfig.getPath();
  container:string = STORAGE_LOCATIONS.PRODUCT_IMAGES;

  constructor(
    private productImageApi: ProductImageApi,
    private modalService: BsModalService,
    private productsService: ProductsService,
    private toast: ToastrService
  ) {
    super();
    this.searchSettings = {
      searchFields: [],
      searchableFields: [
        { name: 'productType', placeholder: 'Product Type', optionsFunction: () => {
          return (this.productsService.getProductTypes() || [])
            .map(productType => {
              return {
                value: productType.name,
                description: productType.description
              };
            });
        } },
        { name: 'description', placeholder: 'Description', wildcard: true }
      ],
      filters: {}
    };
    this.searchSettings.searchFields.push(this.searchSettings.searchableFields[0]);
    this.settings = {
      createComponent: ProductImageFormComponent,
      api: this.productImageApi,
      ModalService: this.modalService
    };
  }

  modify(data) {
    const { id, planType, productType, description } = data;
    this.edit({
      id,
      productType: this.productsService.getProductTypeByName(productType),
      product: this.productsService.getProductByTypeAndPlanCode(productType, planType),
      description
    });
  }

  eventListener(event: Event) {
    switch (event.event) {
      case 'createModal:completed':
        this.toast.success('Product setup successfully created', 'Product Setup');
        this.getList();
        break;
      case 'editModal:completed':
        this.toast.success('Product setup successfully updated', 'Product Setup');
        this.getList();
        break;
      case 'delete:success':
        this.toast.success('Product setup successfully deleted', 'Product Setup');
        this.getList();
        break;
      case 'initialized':
        this.getList();
        break;
    }
  }
}
